export class AssistantCloudThreadMessages {
    cloud;
    constructor(cloud) {
        this.cloud = cloud;
    }
    async list(threadId, query) {
        return this.cloud.makeRequest(`/threads/${encodeURIComponent(threadId)}/messages`, { query });
    }
    async create(threadId, body) {
        return this.cloud.makeRequest(`/threads/${encodeURIComponent(threadId)}/messages`, { method: "POST", body });
    }
}
//# sourceMappingURL=AssistantCloudThreadMessages.js.map